import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { StepperGroupModel } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';
import {
  getBrandModelListSEAT,
  getDriveListSEAT,
  getProductList,
  getSpecialModelListSEAT,
  getSubCategoryList,
  getTrimListSEAT,
} from '../customer/customer-metadata-config';
import { BRANDMARKE } from '../customer/seat/seat-form-fields';
import { Category } from '../customer/vorwerk/vorwerk-metadata-config';

@Injectable()
export class ProductBrandSelectionService {
  /**
   * Vorwerk
   * Update product and subcategory on brand selection
   * @param fieldData
   * @param stepperComponent
   */
  updateOnBrandSelection(fieldData: AnyType, formControl?: AbstractControl<AnyType, AnyType>, sidebarFilters = false, sharingClientFlag?: boolean) {
    const formFields = fieldData.formGroupField.formFields;
    const productFormFieldIndex = formFields.findIndex((field: AnyType) => field.formFieldName === 'product');
    const productList = getProductList(fieldData.event.value?.name?.toLowerCase());
    if (productFormFieldIndex !== -1 && fieldData.event.value && productList.length) {
      formFields[productFormFieldIndex].options = productList;
      if (formFields[productFormFieldIndex].nestedOptions) formFields[productFormFieldIndex].nestedOptions[fieldData.rowIndex] = productList;
      formControl?.get('subcategory')?.setValue(null);
    } else {
      formFields[productFormFieldIndex].options = [];
      if (formFields[productFormFieldIndex].nestedOptions) formFields[productFormFieldIndex].nestedOptions[fieldData.rowIndex] = [];
      formControl?.get('product')?.setValue(null);
      formControl?.get('subcategory')?.setValue(null);
    }

    const categoryList = Category;
    const categoryFormFieldIndex = formFields.findIndex((field: AnyType) => field.formFieldName === 'category');
    if (categoryFormFieldIndex !== -1 && fieldData.event.value) {
      if (sidebarFilters || sharingClientFlag) {
        formFields[categoryFormFieldIndex].visible = true;
        formFields[categoryFormFieldIndex].options = categoryList;
      }
      if (formFields[categoryFormFieldIndex].nestedOptions) formFields[categoryFormFieldIndex].nestedOptions[fieldData.rowIndex] = categoryList;
    }
    // hide subcategory if Brand selection change
    this.hideSubCategory(formFields);
  }

  /**
   * Vorwerk
   * Hide subcategory
   * @param fieldData
   */
  hideSubCategory(formFields: AnyType) {
    const subCatFormFieldIndex = formFields.findIndex((field: AnyType) => field.formFieldName === 'subcategory');
    if (subCatFormFieldIndex !== -1) {
      formFields[subCatFormFieldIndex].visible = false;
      formFields[subCatFormFieldIndex].option = [];
    }
  }

  /**
   * Vorwerk
   * Update product and subcategory on brand selection
   * @param fieldData
   * @param stepperComponent
   */
  updateOnProductSelection(fieldData: AnyType, formControl?: AbstractControl<AnyType, AnyType>, sidebarFilters = false, sharingClientFlag?: boolean) {
    if (fieldData.formFieldName === 'product') {
      const formFields = fieldData.formGroupField.formFields;
      const subcategoryFormFieldIndex = formFields.findIndex((field: AnyType) => field.formFieldName === 'subcategory');
      const subCategoryList = getSubCategoryList(fieldData.event.value?.name?.toLowerCase());
      if (subcategoryFormFieldIndex !== -1 && fieldData.event.value && subCategoryList.length) {
        if (sidebarFilters || sharingClientFlag) {
          formFields[subcategoryFormFieldIndex].visible = true;
        }
        formFields[subcategoryFormFieldIndex].options = subCategoryList;
        if (formFields[subcategoryFormFieldIndex].nestedOptions) formFields[subcategoryFormFieldIndex].nestedOptions[fieldData.rowIndex] = subCategoryList;
      } else {
        formFields[subcategoryFormFieldIndex].options = [];
        if (formFields[subcategoryFormFieldIndex].nestedOptions) formFields[subcategoryFormFieldIndex].nestedOptions[fieldData.rowIndex] = [];
        formControl?.get('subcategory')?.setValue(null);
      }
    }
  }

  /**
   * SEAT
   * Update brandMarke on brand selection
   * @param fieldData
   * @param stepperComponent
   */
  updateOnBrandSelectionSEAT(fieldData: AnyType, formControl?: AbstractControl<AnyType, AnyType>) {
    const formFields = fieldData.formGroupField.formFields;
    const brandMarkeFormFieldIndex = formFields.findIndex((field: AnyType) => field.formFieldName === 'brandMarke');
    if (brandMarkeFormFieldIndex !== -1 && fieldData.event.value && BRANDMARKE.length) {
      formFields[brandMarkeFormFieldIndex].options = BRANDMARKE;
      if (formFields[brandMarkeFormFieldIndex].nestedOptions) formFields[brandMarkeFormFieldIndex].nestedOptions[fieldData.rowIndex] = BRANDMARKE;
    } else {
      formFields[brandMarkeFormFieldIndex].options = [];
      if (formFields[brandMarkeFormFieldIndex].nestedOptions) formFields[brandMarkeFormFieldIndex].nestedOptions[fieldData.rowIndex] = [];
      formControl?.get('brandMarke')?.setValue(null);
    }
  }
  /**
   * SEAT
   * Update product and BrandMarke on brand selection
   * @param fieldData
   * @param stepperComponent
   */

  updateOnBrandMarkeSelectionSEAT(fieldData: AnyType, formControl?: AbstractControl<AnyType, AnyType>, filterFlag?: boolean) {
    const formFields = fieldData.formGroupField.formFields;
    const brandModelFormFieldIndex = formFields.findIndex((field: AnyType) => field.formFieldName === 'brandModel');
    const BrandModelList = getBrandModelListSEAT(fieldData.event.value?.name?.toLowerCase(), filterFlag ? false : true);
    if (brandModelFormFieldIndex !== -1 && fieldData.event.value && BrandModelList.length) {
      formFields[brandModelFormFieldIndex].options = BrandModelList;
      if (formFields[brandModelFormFieldIndex].nestedOptions) formFields[brandModelFormFieldIndex].nestedOptions[fieldData.rowIndex] = BrandModelList;
    } else {
      formFields[brandModelFormFieldIndex].options = [];
      if (formFields[brandModelFormFieldIndex].nestedOptions) formFields[brandModelFormFieldIndex].nestedOptions[fieldData.rowIndex] = [];
      if (formControl) formControl?.get('brandModel')?.setValue(null);
    }
  }

  updateOnBrandModelSelectionSEAT(fieldData: AnyType, formControl?: AbstractControl<AnyType, AnyType>, filterFlag?: boolean) {
    let formFields = [];
    let brandModelValues: string[] = [];
    if (fieldData.initialStepper) {
      const contentDescriptionGroupIndex = fieldData.initialStepper.stepper.findIndex(
        (stepper: StepperGroupModel) => stepper.stepperGroupName === 'contentDescription',
      );
      if (contentDescriptionGroupIndex > -1) {
        formFields = fieldData.initialStepper.stepper[contentDescriptionGroupIndex].formFields;
        const formGroupValue = formControl?.getRawValue().domains;
        formGroupValue.forEach((domain: AnyType) => {
          brandModelValues.push(domain.brandModel._id);
        });
      } else {
        return;
      }
    } else {
      if (fieldData.event.value._id) {
        formFields = fieldData.formGroupField.formFields;
        brandModelValues = [fieldData.event.value._id];
      } else {
        return;
      }
    }
    const specialModelFormFieldIndex = formFields.findIndex((field: AnyType) => field.formFieldName === 'specialModel');
    const trimFormFieldIndex = formFields.findIndex((field: AnyType) => field.formFieldName === 'trim');
    const driveFormFieldIndex = formFields.findIndex((field: AnyType) => field.formFieldName === 'drive');
    const SpecialModelList = getSpecialModelListSEAT(brandModelValues, filterFlag ? false : true);
    const TrimList = getTrimListSEAT(brandModelValues, filterFlag ? false : true);
    const DriveList = getDriveListSEAT(brandModelValues, filterFlag ? false : true);
    if (specialModelFormFieldIndex !== -1) {
      formFields[specialModelFormFieldIndex].options = SpecialModelList;
    }
    if (trimFormFieldIndex !== -1) {
      formFields[trimFormFieldIndex].options = TrimList;
    }
    if (driveFormFieldIndex !== -1) {
      formFields[driveFormFieldIndex].options = DriveList;
    }
  }
}
